import React, { useEffect, useRef, useState } from 'react'
import './App.css'
import './Partner.css'
import { Link } from 'react-router-dom'
import ClipLoader from 'react-spinners/ClipLoader'
import Axios from 'axios'
import validator from 'validator'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { API_URL } from './config'

const Partner = () => {
  const history = useHistory()
  const timeoutRef = useRef(null)

  const [business, setBusiness] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [pass1, setPass1] = useState('')
  const [pass2, setPass2] = useState('')

  const [instagram, setInstagram] = useState('')
  const [facebook, setFacebook] = useState('')
  const [tiktok, setTiktok] = useState('')
  const [x, setX] = useState('')
  const [linkedin, setLinkedin] = useState('')
  const [pitch, setPitch] = useState('')
  const [bio, setBio] = useState('')
  const [estdFollowers, setEstdFollowers] = useState('less than 500')

  const [entity, setEntity] = useState('organisation')

  const [error, setError] = useState('')
  const [errorDisplay, setErrorDisplay] = useState('none')
  const [spinning, setSpinning] = useState(false)
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    document.title = 'Partner Registration'
    localStorage.setItem('entity', 'organisation')

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const clearError = () => {
    setErrorDisplay('none')
  }

  const showError = (message) => {
    setError(message)
    setErrorDisplay('block')

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      setErrorDisplay('none')
    }, 5000)
  }

  const handleBusiness = (event) => {
    setBusiness(event.target.value)
    clearError()
  }

  const handleEmail = (event) => {
    setEmail(event.target.value)
    clearError()
  }

  const handlePassword = (event) => {
    setPass1(event.target.value)
    clearError()
  }

  const handlePassword2 = (event) => {
    setPass2(event.target.value)
    clearError()
  }

  const selectEntity = (selectedEntity) => {
    setEntity(selectedEntity)
    setBusiness('')
    clearError()
    localStorage.setItem('entity', selectedEntity)
  }

  const onSubmitForm = async () => {
    clearError()

    if (business.trim() === '') {
      showError(
        entity === 'organisation'
          ? 'Enter the name of your organisation'
          : 'Enter your name and surname',
      )
      return
    }

    if (email.trim() === '') {
      showError('Enter your email address')
      return
    }

    if (!validator.isEmail(email.trim())) {
      showError('Your email address is invalid')
      return
    }

    if (phone.trim() === '') {
      showError('Enter your phone number')
      return
    }

    if (
      instagram.trim() === '' &&
      facebook.trim() === '' &&
      tiktok.trim() === '' &&
      x.trim() === '' &&
      linkedin.trim() === ''
    ) {
      showError('Please provide at least one social media handle or profile URL.')
      return
    }

    if (pitch.trim() === '') {
      showError('Tell us how you will promote Karamale')
      return
    }

    if (bio.trim() === '') {
      showError('Add your bio or tagline')
      return
    }

    if (pass1.length < 8) {
      showError('Password must be at least 8 characters long.')
      return
    }

    if (pass1 !== pass2) {
      showError('Make sure both your passwords match')
      return
    }

    const baseURL = `${API_URL}/apps/kscanner/webservices.php`

    setDisabled(true)
    setSpinning(true)

    const data = new FormData()

    data.append('account_name', business.trim())
    data.append('phone', phone)
    data.append('email', email.trim())
    data.append('password', pass1)
    data.append('accounttype', 'partner')
    data.append('platform', 'web')
    data.append('partner', 'no')
    data.append('instagram', instagram.trim())
    data.append('facebook', facebook.trim())
    data.append('tiktok', tiktok.trim())
    data.append('x', x.trim())
    data.append('linkedin', linkedin.trim())
    data.append('partner_type', entity)
    data.append('pitch', pitch.trim())
    data.append('bio', bio.trim())
    data.append('follower_estimate', estdFollowers)
    data.append('query', 'VERIFYACCOUNT')

    try {
      const response = await Axios({
        method: 'POST',
        url: baseURL,
        data: data,
        withCredentials: true,
      })

      if (response.data.status === 'success') {
        localStorage.setItem('verificationAccount', 'PARTNER')

        history.push({
          pathname: '/verification',
          state: {
            email: email.trim(),
            accounttype: 'partner',
            password: pass1,
          },
        })

        return
      }

      showError(response.data.message || 'Unable to create your partner account.')
    } catch (err) {
      console.log(err)
      showError('Something went wrong. Please try again.')
    } finally {
      setDisabled(false)
      setSpinning(false)
    }
  }

  return (
    <div className="kx-partner-page">
      <div className="kx-partner-bg">
        <div className="kx-partner-bg__orb kx-partner-bg__orb--one"></div>
        <div className="kx-partner-bg__orb kx-partner-bg__orb--two"></div>
        <div className="kx-partner-bg__grid"></div>
        <div className="kx-partner-bg__word">KARAMALE</div>
      </div>

      <main className="kx-partner">
        <div className="kx-partner__wrap">
          <section className="kx-partner__brand">
            <Link to="/" className="kx-partner__logo">
              karamale.
            </Link>

            <div className="kx-partner__brand-content">
              <div className="kx-partner__eyebrow">BECOME A KARAMALE PARTNER</div>

              <h1>
                Grow your audience.
                <strong>Grow with Karamale.</strong>
              </h1>

              <p>
                Partner with Karamale to connect your audience with events, experiences and
                opportunities while earning commission along the way.
              </p>

              <div className="kx-partner__features">
                <div className="kx-partner__feature">
                  <span className="kx-partner__feature-mark">01</span>
                  <span>Reach event audiences</span>
                </div>

                <div className="kx-partner__feature">
                  <span className="kx-partner__feature-mark">02</span>
                  <span>Promote Karamale</span>
                </div>

                <div className="kx-partner__feature">
                  <span className="kx-partner__feature-mark">03</span>
                  <span>Earn partner commission</span>
                </div>
              </div>
            </div>

            <div className="kx-partner__brand-footer">
              <span>Already have an account?</span>
              <Link to="/login">Log in</Link>
            </div>
          </section>

          <section className="kx-partner__panel">
            <div className="kx-partner__card">
              <div className="kx-partner__card-head">
                <span className="kx-partner__card-kicker">PARTNER ACCOUNT</span>

                <h2>Become a Karamale partner</h2>

                <p>Tell us about yourself and how you plan to promote Karamale.</p>
              </div>

              <div className="kx-partner__entity">
                <button
                  type="button"
                  className={
                    entity === 'organisation'
                      ? 'kx-partner__entity-option is-active'
                      : 'kx-partner__entity-option'
                  }
                  onClick={() => selectEntity('organisation')}
                >
                  <span className="kx-partner__entity-radio">
                    <span></span>
                  </span>

                  <span className="kx-partner__entity-copy">
                    <strong>Organisation</strong>
                    <small>Representing a business or organisation</small>
                  </span>
                </button>

                <button
                  type="button"
                  className={
                    entity === 'individual'
                      ? 'kx-partner__entity-option is-active'
                      : 'kx-partner__entity-option'
                  }
                  onClick={() => selectEntity('individual')}
                >
                  <span className="kx-partner__entity-radio">
                    <span></span>
                  </span>

                  <span className="kx-partner__entity-copy">
                    <strong>Individual</strong>
                    <small>Promoting Karamale independently</small>
                  </span>
                </button>
              </div>

              <div className="kx-partner__form">
                <div className="kx-partner__form-row">
                  <div className="kx-partner__field">
                    <label>
                      {entity === 'organisation' ? 'Organisation name' : 'Name and surname'}
                    </label>

                    <input
                      required
                      type="text"
                      name="business"
                      placeholder={
                        entity === 'organisation' ? 'Name of your organisation' : 'Name and surname'
                      }
                      value={business}
                      onChange={handleBusiness}
                    />
                  </div>

                  <div className="kx-partner__field">
                    <label>Email address</label>

                    <input
                      required
                      type="email"
                      name="email"
                      placeholder="Email address"
                      value={email}
                      onChange={handleEmail}
                    />
                  </div>
                </div>

                <div className="kx-partner__field">
                  <label>Phone number</label>

                  <PhoneInput
                    disableDropdown={true}
                    country="za"
                    value={phone}
                    onChange={(value) => {
                      setPhone(value)
                      clearError()
                    }}
                    inputStyle={{
                      width: '100%',
                    }}
                    containerStyle={{
                      width: '100%',
                    }}
                    inputProps={{
                      name: 'phone',
                      required: true,
                    }}
                  />
                </div>

                <div className="kx-partner__section">
                  <div className="kx-partner__section-heading">
                    <span>YOUR AUDIENCE</span>
                    <small>At least one profile is required</small>
                  </div>

                  <div className="kx-partner__form-row">
                    <div className="kx-partner__field">
                      <label>Instagram</label>

                      <input
                        name="instagram_handle"
                        placeholder="@yourusername"
                        value={instagram}
                        onChange={(e) => {
                          setInstagram(e.target.value)
                          clearError()
                        }}
                      />
                    </div>

                    <div className="kx-partner__field">
                      <label>Facebook</label>

                      <input
                        name="facebook_profile"
                        placeholder="Facebook profile URL"
                        value={facebook}
                        onChange={(e) => {
                          setFacebook(e.target.value)
                          clearError()
                        }}
                      />
                    </div>
                  </div>

                  <div className="kx-partner__form-row">
                    <div className="kx-partner__field">
                      <label>TikTok</label>

                      <input
                        name="tiktok_handle"
                        placeholder="@yourusername"
                        value={tiktok}
                        onChange={(e) => {
                          setTiktok(e.target.value)
                          clearError()
                        }}
                      />
                    </div>

                    <div className="kx-partner__field">
                      <label>X / Twitter</label>

                      <input
                        name="x_handle"
                        placeholder="@yourusername"
                        value={x}
                        onChange={(e) => {
                          setX(e.target.value)
                          clearError()
                        }}
                      />
                    </div>
                  </div>

                  <div className="kx-partner__form-row">
                    <div className="kx-partner__field">
                      <label>LinkedIn</label>

                      <input
                        name="linkedin_profile"
                        placeholder="LinkedIn profile URL"
                        value={linkedin}
                        onChange={(e) => {
                          setLinkedin(e.target.value)
                          clearError()
                        }}
                      />
                    </div>

                    <div className="kx-partner__field">
                      <label>Estimated followers</label>

                      <select
                        value={estdFollowers}
                        onChange={(e) => {
                          setEstdFollowers(e.target.value)
                          clearError()
                        }}
                      >
                        <option value="less than 500">Less than 500</option>
                        <option value="500-2K">500–2K</option>
                        <option value="2K-10K">2K–10K</option>
                        <option value="10K+">10K+</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="kx-partner__section">
                  <div className="kx-partner__section-heading">
                    <span>ABOUT YOU</span>
                  </div>

                  <div className="kx-partner__field">
                    <label>How will you promote Karamale?</label>

                    <textarea
                      name="pitch"
                      value={pitch}
                      placeholder="Tell us how you plan to promote Karamale."
                      onChange={(e) => {
                        setPitch(e.target.value)
                        clearError()
                      }}
                    />
                  </div>

                  <div className="kx-partner__field">
                    <label>Bio or tagline</label>

                    <textarea
                      name="bio"
                      value={bio}
                      placeholder="A short bio or tagline."
                      onChange={(e) => {
                        setBio(e.target.value)
                        clearError()
                      }}
                    />
                  </div>
                </div>

                <div className="kx-partner__section">
                  <div className="kx-partner__section-heading">
                    <span>CREATE YOUR PASSWORD</span>
                  </div>

                  <div className="kx-partner__form-row">
                    <div className="kx-partner__field">
                      <label>Password</label>

                      <input
                        type="password"
                        placeholder="At least 8 characters"
                        value={pass1}
                        onChange={handlePassword}
                      />
                    </div>

                    <div className="kx-partner__field">
                      <label>Confirm password</label>

                      <input
                        required
                        type="password"
                        placeholder="Retype your password"
                        value={pass2}
                        onChange={handlePassword2}
                      />
                    </div>
                  </div>
                </div>

                <div className="kx-partner__error" style={{ display: errorDisplay }}>
                  {error}
                </div>

                <button
                  type="button"
                  onClick={onSubmitForm}
                  className="kx-partner__submit"
                  disabled={disabled}
                >
                  {spinning ? (
                    <ClipLoader color="#ffffff" loading={true} size={20} />
                  ) : (
                    <>
                      <span>Create partner account</span>
                      <span className="kx-partner__submit-arrow">→</span>
                    </>
                  )}
                </button>

                <div className="kx-partner__login">
                  <span>Already have an account?</span>
                  <Link to="/login">Log in →</Link>
                </div>

                <Link to="/registration" className="kx-partner__back">
                  ← Back to Karamale
                </Link>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  )
}

export default Partner
